import { cva } from 'class-variance-authority'

export const messageVariants = cva(
  'w-full text-sm rounded-lg border-none p-3 flex space-x-2 items-start',
  {
    variants: {
      variant: {
        info: 'bg-blue-50 dark:bg-blue-950 text-blue-600 dark:text-blue-300 fill-blue-600 dark:fill-blue-300',
        warning:
          'bg-orange-50 dark:bg-orange-950 text-orange-600 dark:text-orange-400 fill-orange-600 dark:fill-orange-400',
        success:
          'bg-green-50 dark:bg-green-950 text-green-600 dark:text-green-300 fill-green-600 dark:fill-green-300',
        danger:
          'bg-red-50 dark:bg-red-950 text-red-600 dark:text-red-300 fill-red-600 dark:fill-red-300',
        neutral: 'bg-gray-100 dark:bg-gray-800 text-secondary',
      },
    },
    defaultVariants: {
      variant: 'info',
    },
  },
)

// Blends a Message's secondary actions into it: a mostly white fill picks up a
// hint of the message's background, the outline takes its border color and
// the label a deep shade of its hue (7:1+ on that fill). Severity is already
// carried by the message itself, and a colored fill would read as a
// destructive action. The fill classes mirror the Button secondary ones (same
// modifiers) so tailwind-merge replaces them.
export const messageActionVariants = cva(
  'bg-white/80 hover:bg-white disabled:hover:bg-white/80 dark:bg-white/5 dark:hover:bg-white/10 dark:disabled:hover:bg-white/5',
  {
    variants: {
      variant: {
        info: 'text-blue-800 ring-blue-200 dark:text-blue-100 dark:ring-blue-800',
        warning:
          'text-orange-800 ring-orange-200 dark:text-orange-100 dark:ring-orange-800',
        success:
          'text-green-800 ring-green-200 dark:text-green-100 dark:ring-green-800',
        danger: 'text-red-800 ring-red-200 dark:text-red-100 dark:ring-red-800',
        neutral: '',
      },
    },
  },
)
